import Vue from 'vue'
import { Spinner } from 'spin.js'
import Plugin from './plugin'

Vue.use(Plugin, new Spinner({
  color: '#f3a660',
  position: 'fixed'
}))



// WEBPACK FOOTER //
// ./src/configs/spinner/index.js